import { Component, EventEmitter, Output } from '@angular/core';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-companies-header',
  templateUrl: './companies-header.component.html',
  styleUrls: ['./companies-header.component.scss'],
})
export class CompaniesHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();

  constructor(private navigation_service: NavigationService) {}

  onArchiveClick(): void {
    this.navigation_service.toArchive();
  }
}
